import * as L from 'leaflet';
import { environment } from 'src/environments/environment';

const isSentinelBaseMapEnabled =
  environment.enableSentinelBaseMap === 'true';

const sentinelLayer = environment.isCopernicusLoad === "true"
  ? L.tileLayer(
      'https://sh.dataspace.copernicus.eu/ogc/wmts/f8b2a869-bd69-4ac6-8791-3443f116fa98' +
        '?SERVICE=WMTS' +
        '&REQUEST=GetTile' +
        '&VERSION=1.0.0' +
        '&LAYER=S2BASEMAP-LAYER' +
        '&STYLE=default' +
        '&FORMAT=image/png' +
        '&TILEMATRIXSET=PopularWebMercator256' +
        '&TILEMATRIX={z}' +
        '&TILEROW={y}' +
        '&TILECOL={x}',
      {
        attribution:
          '© Copernicus Sentinel | © Sentinel-2 Cloudless',
        tileSize: 256,
        opacity: 1
      }
    )
  : L.tileLayer(
      'https://tiles.maps.eox.at/wmts/1.0.0/s2cloudless-2020_3857/default/g/{z}/{y}/{x}.jpg',
      {
        attribution:
          '<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>',
        tileSize: 256,
        opacity: 1
      }
    );

export const baseLayers: Record<string, L.TileLayer> = {
  Openstreetmap: L.tileLayer(
    'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    {
      crossOrigin: true,
    }
  ),
  ...(isSentinelBaseMapEnabled ? { Sentinel: sentinelLayer } : {})
};

export const overlays = {};